const organizations = {
    title: 'المؤسسات',
    description: 'أنشئ المؤسسات التي تنتمي إليها وأدرها.',
    create: 'إنشاء مؤسسة',
    create_title: 'إنشاء مؤسسة جديدة',
    name: 'اسم المؤسسة',
    avatar: 'الصورة الرمزية للمؤسسة',
    avatar_removed: 'تمت إزالة الصورة الرمزية للمؤسسة.',
    description_label: 'الوصف',
    empty: 'لست عضواً في أي مؤسسة بعد.',
    pending_invitations: 'الدعوات المعلقة',
    accept: 'قبول',
    decline: 'رفض',
    owner: 'المالك',
    tabs: {
        overview: 'نظرة عامة',
        members: 'الأعضاء',
        invitations: 'الدعوات',
        roles: 'أدوار الإدارة',
        branding: 'الهوية البصرية',
        security: 'الأمان',
        jit: 'التزويد الفوري',
        applications: 'الموارد المشتركة',
        activity: 'النشاط',
        deletion: 'حذف',
    },
    members: {
        title: 'الأعضاء',
        empty: 'لم يتم العثور على أعضاء.',
        remove: 'إزالة',
        removed: 'تمت إزالة العضو.',
        business_roles: 'أدوار الأعمال',
        no_business_roles: 'لا توجد أدوار أعمال متاحة. اطلب من مسؤول المستأجر مشاركة أدوار مع هذه المؤسسة.',
    },
    invitations: {
        title: 'الدعوات',
        invite: 'دعوة عضو',
        email: 'البريد الإلكتروني',
        empty: 'لم يتم العثور على دعوات.',
        resend: 'إعادة الإرسال',
        resent: 'تمت إعادة إرسال الدعوة.',
        revoke: 'إلغاء الدعوة',
        revoked: 'تم إلغاء الدعوة.',
        status: {
            Pending: 'معلقة',
            Accepted: 'مقبولة',
            Expired: 'منتهية الصلاحية',
            Revoked: 'ملغاة',
            Declined: 'مرفوضة',
        },
    },
    roles: {
        title: 'أدوار الإدارة',
        create: 'إنشاء دور',
        permissions: 'الصلاحيات',
        empty: 'لم يتم العثور على أدوار إدارة.',
        select_member: 'اختيار عضو',
        select_role: 'اختيار دور',
        assign: 'تعيين دور',
        assigned: 'تم تعيين الدور.',
        unassign: 'إزالة الدور',
        unassigned: 'تمت إزالة الدور.',
        permission_count: 'عدد الصلاحيات: {{count}}',
        built_in: {
            owner: 'المالك',
            owner_description: 'للمالكين صلاحيات حصرية لإدارة الملكية وحذف المؤسسة.',
            administrator: 'المسؤول',
            administrator_description: 'يدير المؤسسة باستثناء العمليات المخصصة للمالكين.',
        },
        permission_labels: {
            update_profile: 'تحديث الملف التعريفي',
            manage_branding: 'إدارة الهوية البصرية',
            view_members: 'عرض الأعضاء',
            manage_members: 'إدارة الأعضاء',
            manage_invitations: 'إدارة الدعوات',
            assign_business_roles: 'تعيين أدوار الأعمال',
            manage_management_roles: 'إدارة أدوار الإدارة',
            assign_management_roles: 'تعيين أدوار الإدارة',
            manage_security: 'إدارة الأمان',
            manage_jit: 'إدارة التزويد الفوري',
            manage_applications: 'إدارة التطبيقات',
            view_activity: 'عرض النشاط',
        },
    },
    branding: {
        title: 'الهوية البصرية للمؤسسة',
        primary_color: 'اللون الأساسي',
        custom_css: 'CSS مخصص',
        preview: 'معاينة',
        light: 'فاتح',
        dark: 'داكن',
    },
    security: {
        title: 'أمان المؤسسة',
        require_mfa: 'إلزام الأعضاء بالمصادقة متعددة العوامل',
    },
    jit: {
        title: 'نطاقات البريد للتزويد الفوري',
        domain: 'نطاق البريد الإلكتروني',
        add: 'إضافة نطاق',
        verify: 'فحص DNS',
        dns_instruction: 'أنشئ سجل TXT باسم {{record}} وبالقيمة {{value}}.',
        verified: 'تم التحقق',
    },
    applications: {
        title: 'الموارد المشتركة',
        empty: 'لا توجد موارد متاحة لهذه المؤسسة.',
        sso: 'اتصالات الدخول الموحد للمؤسسات',
        m2m: 'تطبيقات الاتصال بين الآلات',
    },
    activity: {
        title: 'نشاط المؤسسة',
        empty: 'لا يوجد نشاط بعد.',
        events: {
            create: 'تم إنشاء المؤسسة',
            delete: 'تم حذف المؤسسة',
            profile: 'تم تحديث الملف التعريفي للمؤسسة',
            branding: 'تم تحديث الهوية البصرية للمؤسسة',
            security: 'تم تحديث أمان المؤسسة',
            member_add: 'تمت إضافة عضو',
            member_remove: 'تمت إزالة عضو',
            owner: 'تم تحديث ملكية المؤسسة',
            role_create: 'تم إنشاء دور إدارة',
            role_update: 'تم تحديث دور إدارة',
            role_delete: 'تم حذف دور إدارة',
            role_assign: 'تم تعيين دور إدارة',
            role_unassign: 'تمت إزالة دور الإدارة من العضو',
            business_role: 'تم تحديث أدوار الأعمال',
            invitation_create: 'تم إرسال دعوة',
            invitation_accept: 'تم قبول الدعوة',
            invitation_decline: 'تم رفض الدعوة',
            invitation_revoke: 'تم إلغاء الدعوة',
            jit: 'تم تحديث التزويد الفوري',
            domain: 'التحقق من نطاق البريد الإلكتروني',
            application: 'تم تحديث اتصالات التطبيقات',
            unknown: 'نشاط المؤسسة',
        },
    },
    save: 'حفظ التغييرات',
    cancel: 'إلغاء',
    delete: 'حذف المؤسسة',
    delete_confirmation: 'سيؤدي هذا إلى حذف المؤسسة وعضوياتها نهائياً. أدخل «{{name}}» للتأكيد.',
    deleted: 'تم حذف المؤسسة.',
    load_failed: 'تعذر تحميل بيانات المؤسسة. حاول مرة أخرى.',
    permission_denied: 'ليس لديك صلاحية لعرض هذا القسم.',
};
export default organizations;
